import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectFormField, TSelectOption } from '@spotted-zebra-uk/ui-components';
import { IDeiFormFieldProps } from './StageActionDeiForm.interfaces';
import styles from './StageActionDeiForm.module.scss';

const DeiSelectFormField = ({
  id,
  options,
  value,
  onChange,
  error,
  description,
}: IDeiFormFieldProps) => {
  const { t } = useTranslation();

  const translatedOptions = useMemo(() => {
    return options?.map(option => ({
      label: t(`test.dei.${option.label}`),
      value: option.value,
    }));
  }, [id, options, t]);

  return (
    <div className={styles.formFieldContainer}>
      <label>{t(`test.dei.${id}`)}</label>
      {description && (
        <p className={styles.description}>{t(`test.dei.${description}`)}</p>
      )}
      <div className={styles.formField}>
        <SelectFormField
          label={t(`test.dei.option`)}
          placeholder={t(`test.dei.option`)}
          // Explicit types: the ui-components dist d.ts fails to resolve its
          // internal '@/widgets/select-form-field' alias, so SelectFormField's
          // onChange signature degrades and the params become implicit any.
          onChange={(newValue: TSelectOption, fieldId: string) =>
            onChange(
              { label: newValue.label ?? '', value: newValue.value ?? '' },
              fieldId
            )
          }
          value={value}
          id={id}
          name={id}
          options={translatedOptions || []}
          hasError={!!error}
          bottomText={error}
        />
      </div>
    </div>
  );
};

export default DeiSelectFormField;
